/* eslint-disable jquery/no-class */
import $ from 'jquery';
import { initFlyout } from '../../components/flyoutUnderHeader';
import scrollTo from '../../util/scrollTo';
import { loadContent, CONTENT_TYPES } from '../../util/fetchutils';

const CONSTANTS = {
  HASH_TRIGGER: 'reviews',
};

const SELECTORS = {
  CONTAINER: '.product-reviews',
  REVIEW_SECTION: '.reviewSection',
  REVIEW: '.product_reviews .product-detail__rating__review',
  LOAD_MORE_BUTTON: '.product-detail__rating__more-btn',
  VISIBLE_REVIEWS_COUNT: '.product-detail__rating__visible-reviews',
  ITEMS_CONTAINER: '.product-detail__rating__reviews',
  SORT_DROPDOWN: '.product-detail__rating__reviews-sort',
};

let currentPage = 1;

const getReviews = () => Array.prototype.slice.call(document.querySelectorAll(SELECTORS.REVIEW));

const initReviewsPagination = (loadMoreButton, visibleCountContainer) => {
  const { pageSize: pageSizeStr } = loadMoreButton.dataset;

  if (pageSizeStr) {
    const pageSize = parseInt(pageSizeStr, 10);

    if (!Number.isNaN(pageSize)) {
      loadMoreButton.addEventListener('click', () => {
        const items = getReviews();
        const firstPageIndex = items.findIndex(el => el.classList.contains('d-none'));
        const lastPageIndex = Math.min(items.length, firstPageIndex + pageSize);
        const pageItems = items.slice(firstPageIndex, lastPageIndex);

        pageItems.forEach((item) => {
          item.classList.remove('d-none');
        });

        if (lastPageIndex >= items.length) {
          loadMoreButton.remove();
        }

        if (visibleCountContainer) {
          visibleCountContainer.innerHTML = lastPageIndex;
        }
      });
    }
  }
};

async function setReviewSorting() {
  const reviewsContainer = document.querySelector(SELECTORS.CONTAINER);
  const sortReviewsDropdown = reviewsContainer.querySelector(SELECTORS.SORT_DROPDOWN);
  const reviewItemsContainer = reviewsContainer.querySelector(SELECTORS.ITEMS_CONTAINER);

  if (sortReviewsDropdown && reviewItemsContainer) {
    sortReviewsDropdown.addEventListener('change', async () => {
      await getAllProductReviews(true);
      scrollPostion();
    });
  }
}

async function getAllProductReviews(resetPage = false) {
  const reviewsSection = document.querySelector(SELECTORS.REVIEW_SECTION);

  const pageNumber = document.querySelector('.js-page-count.active')
    && document.querySelector('.js-page-count.active').dataset.page;
  const sortOption = document.querySelector('.js-product-reviews-sort');
  let reviewsParam = null;

  if (pageNumber && sortOption) {
    reviewsParam = {
      page: resetPage ? 1 : (Number(pageNumber) || 1),
      sort: sortOption.value || 'date_desc',
      callAPI: 'true',
    };
  }

  const { type, content } = await loadContent(reviewsSection, null, reviewsParam);
  if (type === CONTENT_TYPES.TEXT) {
    reviewsSection.innerHTML = content;
    reviewsSection.setAttribute('initialized', 'true');

    if (resetPage) {
      currentPage = 1;
    }

    updatePagination();
    setReviewSorting();
  }
}

const handleDisplayOnLoad = (reviewsContainer) => {
  const hash = window.location.hash.replace('#', '');
  const hashParts = hash.split('&');

  if (hashParts.indexOf(CONSTANTS.HASH_TRIGGER) >= 0) {
    $(reviewsContainer).collapse('show');

    // Remove the reviews trigger from the current hash so they don't get opened
    // again on refresh or on attribute change
    const hashNoReviews = hashParts.filter(part => part !== CONSTANTS.HASH_TRIGGER).join('&');

    window.location.hash = hashNoReviews;
  }
};

// Pagination
// eslint-disable-next-line jquery/no-data
let totalPages = $('.pagination-container').data('total');
const maxVisiblePages = 3; // Maximum visible page numbers

async function updatePagination() {
  const pageNumbersContainer = document.getElementById('page-numbers');
  // eslint-disable-next-line jquery/no-data
  totalPages = $('.pagination-container').data('total');
  pageNumbersContainer.innerHTML = ''; // Clear previous page numbers

  // Calculate start and end pages for the range
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  // Adjust startPage if endPage is near the end
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  // Add "1" and "2" if startPage > 2
  if (startPage > 1) {
    createPageNumber(1);
    if (startPage > 2) {
      createEllipsis();
    }
  }

  // Add page numbers in the range
  for (let i = startPage; i <= endPage; i++) {
    createPageNumber(i);
  }

  // Add ellipsis and last page if endPage < totalPages
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      createEllipsis();
    }
    createPageNumber(totalPages);
  }

  // Update buttons
  if (totalPages > 4) {
    document.getElementById('prev-btn').disabled = currentPage === 1;
    document.getElementById('next-btn').disabled = currentPage === totalPages;
    // eslint-disable-next-line no-cond-assign
    if (document.getElementById('prev-btn').disabled = currentPage === 1 && !$('#prev-btn').hasClass('keep')) {
      // eslint-disable-next-line jquery/no-hide
      $('#prev-btn').hide();
    } else {
      // eslint-disable-next-line jquery/no-show
      $('#prev-btn').show();
    }
  }
}

function createPageNumber(page) {
  const pageNumber = document.createElement('div');
  pageNumber.textContent = page;
  pageNumber.dataset.page = page;
  pageNumber.dataset.item = page;
  pageNumber.className = 'page-number reviewcount js-page-count';
  if (page === currentPage) {
    pageNumber.classList.add('active');
  }
  pageNumber.onclick = () => goToPage(page);
  document.getElementById('page-numbers').appendChild(pageNumber);
}

function createEllipsis() {
  const ellipsis = document.createElement('div');
  ellipsis.textContent = '...';
  ellipsis.className = 'page-number disabled';
  document.getElementById('page-numbers').appendChild(ellipsis);
}

function goToPage(page) {
  currentPage = page;
  updatePagination();
}

async function prevPage() {
  if (currentPage > 1) {
    currentPage--;
    // eslint-disable-next-line jquery/no-data
    const dataVal = $('.reviewcount.active').data('item');
    const current = dataVal - 1;
    await updatePagination();
    await getAllProductReviews();
    updatePaginationArrow(current);
  }
}

function updatePaginationArrow(current) {
  if ($('#next-btn').hasClass('keep')) {
    if (current === totalPages) {
      $('#next-btn').addClass('disabled');
    }
    if (current !== totalPages && $('#next-btn').hasClass('disabled')) {
      $('#next-btn').removeClass('disabled');
    }
  }
  if ($('#prev-btn').hasClass('keep')) {
    if (current !== 1 && $('#prev-btn').hasClass('disabled')) {
      $('#prev-btn').removeClass('disabled');
    }
    if (current === 1) {
      $('#prev-btn').addClass('disabled');
    }
  }
}

async function nextPage() {
  if (currentPage < totalPages) {
    currentPage++;
    // eslint-disable-next-line jquery/no-data
    const dataVal = $('.reviewcount.active').data('item');
    const current = dataVal + 1;
    await updatePagination();
    await getAllProductReviews();
    updatePaginationArrow(current);
  }
}

// Initialize pagination on page load
$(document).on('click', '#next-btn', async () => {
  await nextPage();
  scrollPostion();
});

$(document).on('click', '#prev-btn', async () => {
  await prevPage();
  scrollPostion();
});

if (totalPages > 1) {
  updatePagination();
}

function scrollPostion() {
  const ctaContainer = document.querySelector('.productreviews-section');
  scrollTo(ctaContainer, true);
}

// END

export default () => {
  const reviewsContainer = document.querySelector(SELECTORS.CONTAINER);
  const reviewsSection = document.querySelector(SELECTORS.REVIEW_SECTION);

  if (reviewsContainer) {
    const sortReviewsDrowpdown = reviewsContainer.querySelector(SELECTORS.SORT_DROPDOWN);
    const reviewItemsContainer = reviewsContainer.querySelector(SELECTORS.ITEMS_CONTAINER);
    const loadMoreReviewsButton = reviewsContainer.querySelector(SELECTORS.LOAD_MORE_BUTTON);
    const visibleReviewsCountContainer = reviewsContainer.querySelector(SELECTORS.VISIBLE_REVIEWS_COUNT);

    initFlyout(reviewsContainer);

    if (sortReviewsDrowpdown && reviewItemsContainer) {
      setReviewSorting();
    }

    if (loadMoreReviewsButton && visibleReviewsCountContainer) {
      initReviewsPagination(loadMoreReviewsButton, visibleReviewsCountContainer);
    }

    handleDisplayOnLoad(reviewsContainer);

    reviewsContainer.setAttribute('initialized', 'true');
  }

  if (reviewsSection) {
    const isLazyLoadEnabled = reviewsSection.getAttribute('data-lazy-load');

    if (isLazyLoadEnabled === 'true' && reviewsSection.getAttribute('initialized') !== 'true') {
      getAllProductReviews();
    }
  }

  $(document).on('click', '.reviewcount ', async () => {
    await getAllProductReviews();
    scrollPostion();
  });

  $(document).on('click', '.rating-scroll ', () => {
    scrollPostion();
  });
};
